import * as React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from 'helpers/theme';
import QuickInfo from '../../../components/Overview/QuickInfo';
import Courses from 'components/Menu/SideMenu/Icons/Courses';
import Certificates from 'components/Menu/SideMenu/Icons/Certificates';
import Expires from 'components/Menu/SideMenu/Icons/Expires';
import Calendar from 'components/Menu/SideMenu/Icons/Calendar';
import DataItem from './DataItem';
import {
  faAlarmClock,
  faAlarmExclamation,
  faBookOpenCover,
  faFileCertificate,
  faTimer
} from '@fortawesome/pro-duotone-svg-icons';
import Card from './Card';

const useStyles = createUseStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem'
  },
  spacer: {
    width: theme.spacing(3)
  },
  summaryRoot: {
    maxWidth: 'fit-content'
  }
}));

type Props = {
  numActiveCourses: number;
  numLastActive: number;
  numCertificates: number;
  numExpiringSoon: number;
};

function Summary({
  numActiveCourses,
  numLastActive,
  numCertificates,
  numExpiringSoon
}: Props) {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <Card
      padding={'0.8rem'}
      title={'Profile summary'}
      className={classes.summaryRoot}
    >
      <div className={classes.root}>
        <DataItem
          icon={numExpiringSoon > 0 ? faAlarmExclamation : faAlarmClock}
          label="Expires soon"
          iconColor={numExpiringSoon > 0 ? '#DD8818' : '#6A728F'}
          style={{ width: '12rem' }}
          helpText="Courses that are expiring in the next 28 days"
        >
          {numExpiringSoon}
        </DataItem>
        <DataItem
          icon={faBookOpenCover}
          label="Active Courses"
          iconColor={'#6A728F'}
          style={{ width: '12rem' }}
          helpText="Courses currently being taken"
        >
          {numActiveCourses}
        </DataItem>
        <DataItem
          icon={faFileCertificate}
          label="Certificates"
          iconColor={'#6A728F'}
          style={{ width: '12rem' }}
          helpText="Number of course certificates"
        >
          {numCertificates}
        </DataItem>
        <DataItem
          icon={faTimer}
          label="Since last active"
          iconColor={'#6A728F'}
          style={{ width: '12rem' }}
          helpText="Last time this user logged in"
        >
          {numLastActive >= 0 ? `${numLastActive}d` : 'Never'}
        </DataItem>
      </div>
    </Card>
  );
}

export default Summary;
